export const GLOSSARY = [
    // ── government contracting ──
    { term: "SAM.gov", full: "System for Award Management", note: "The federal website where opportunities are posted and contractors register." },
    { term: "SAM", full: "System for Award Management", note: "The federal registry of contractors and posted opportunities." },
    { term: "NAICS", full: "North American Industry Classification System", note: "The industry code on a solicitation and on a company's registration." },
    { term: "PSC", full: "Product and Service Code", note: "The federal code for what is being bought." },
    { term: "UEI", full: "Unique Entity Identifier", note: "A contractor's 12-character ID in SAM." },
    { term: "CAGE", full: "Commercial and Government Entity", note: "The five-character code that identifies a contractor." },
    { term: "DUNS", full: "Data Universal Numbering System", note: "The older contractor ID that the UEI replaced." },
    { term: "EIN", full: "Employer Identification Number" },
    { term: "SBIR", full: "Small Business Innovation Research", note: "Federal research and development awards for small businesses." },
    { term: "STTR", full: "Small Business Technology Transfer", note: "Like SBIR, with a research institution as a partner." },
    { term: "SBA", full: "Small Business Administration" },
    { term: "SDVOSB", full: "service-disabled veteran-owned small business", note: "VETS holds this status." },
    { term: "VOSB", full: "veteran-owned small business" },
    { term: "EDWOSB", full: "economically disadvantaged women-owned small business" },
    { term: "WOSB", full: "women-owned small business" },
    { term: "HUBZone", full: "Historically Underutilized Business Zone" },
    { term: "RFI", full: "request for information" },
    { term: "RFP", full: "request for proposal" },
    { term: "RFQ", full: "request for quotation" },
    { term: "IDIQ", full: "indefinite delivery, indefinite quantity", note: "A contract that sets terms now and orders work later." },
    { term: "OTA", full: "other transaction authority", note: "A flexible agreement outside the normal federal buying rules, common for prototypes." },
    { term: "BAFO", full: "best and final offer" },
    { term: "FPR", full: "final proposal revision" },
    { term: "FAR", full: "Federal Acquisition Regulation" },
    { term: "DFARS", full: "Defense Federal Acquisition Regulation Supplement" },
    { term: "CMMC", full: "Cybersecurity Maturity Model Certification", note: "The Defense Department's cybersecurity standard for contractors." },
    { term: "NIST", full: "National Institute of Standards and Technology" },
    { term: "SPRS", full: "Supplier Performance Risk System", note: "Where a contractor's NIST 800-171 score is posted." },
    { term: "CUI", full: "Controlled Unclassified Information" },
    { term: "FCL", full: "facility clearance" },
    { term: "PCL", full: "personnel clearance" },
    { term: "FOCI", full: "foreign ownership, control or influence", note: "Foreign ties that must be mitigated before a company can hold a clearance." },
    { term: "CFIUS", full: "Committee on Foreign Investment in the United States" },
    { term: "ITAR", full: "International Traffic in Arms Regulations" },
    { term: "EAR", full: "Export Administration Regulations" },
    { term: "TRL", full: "technology readiness level", note: "A 1 to 9 scale of how mature a technology is." },
    { term: "USG", full: "U.S. government" },
    { term: "DoD SAFE", full: "Department of Defense Secure Access File Exchange" },
    { term: "DoD", full: "Department of Defense" },
    { term: "GSA MAS", full: "General Services Administration Multiple Award Schedule" },
    { term: "GSA", full: "General Services Administration" },
    { term: "MDA", full: "Missile Defense Agency" },
    { term: "SHIELD", full: "Scalable Homeland Innovative Enterprise Layered Defense", note: "The Missile Defense Agency's multiple-award contract VETS holds." },
    { term: "EWAAC", full: "Enterprise-Wide Agile Acquisition Contract" },
    { term: "USAF", full: "U.S. Air Force" },
    { term: "SDA", full: "Space Development Agency" },
    { term: "SpEC", full: "Space Enterprise Consortium" },
    { term: "USSOCOM", full: "U.S. Special Operations Command" },
    { term: "NSWC", full: "Naval Surface Warfare Center" },
    { term: "C-UAS", full: "counter-unmanned aircraft systems" },
    { term: "UAS", full: "unmanned aircraft systems" },
    { term: "MBSE", full: "model-based systems engineering" },
    { term: "FOC", full: "full operational capability" },
    { term: "IOC", full: "initial operational capability" },
    { term: "ISO", full: "International Organization for Standardization" },
    // ── company, deals and process ──
    { term: "LOI", full: "letter of intent", plural: "letters of intent" },
    { term: "NDA", full: "non-disclosure agreement", plural: "non-disclosure agreements" },
    { term: "POC", full: "point of contact", plural: "points of contact" },
    { term: "CEO", full: "chief executive officer" },
    { term: "CTO", full: "chief technology officer" },
    { term: "SPV", full: "special purpose vehicle", plural: "special purpose vehicles", note: "A separate company set up to raise money for one purpose." },
    { term: "QIAIF", full: "Qualifying Investor Alternative Investment Fund", note: "An Irish fund type for professional investors." },
    { term: "ICAV", full: "Irish Collective Asset-management Vehicle" },
    { term: "EU", full: "European Union" },
    { term: "ERP", full: "enterprise resource planning", note: "The business software that runs accounting, purchasing and inventory." },
    { term: "KPI", full: "key performance indicator", plural: "key performance indicators" },
    { term: "IPAO", full: "Inputs, Process, Artifacts, Outputs", note: "How each of the 12 pipeline stages is described." },
    { term: "SLA", full: "service-level agreement", note: "Here, the time a person has to act on a gate." },
    { term: "QA", full: "quality assurance" },
    { term: "D&B", full: "Dun & Bradstreet" },
    // ── the listing program ──
    { term: "TSE", full: "The Stock Exchange", note: "Where a company lists its shares. For the listing section that is Nasdaq." },
    { term: "IPO", full: "initial public offering" },
    { term: "SEC", full: "Securities and Exchange Commission" },
    { term: "FINRA", full: "Financial Industry Regulatory Authority" },
    { term: "DTC", full: "Depository Trust Company" },
    { term: "PCAOB", full: "Public Company Accounting Oversight Board" },
    { term: "NYSE", full: "New York Stock Exchange" },
    { term: "EGC", full: "emerging growth company" },
    { term: "FPI", full: "foreign private issuer" },
    { term: "CUSIP", full: "Committee on Uniform Securities Identification Procedures", note: "The nine-character ID for a security." },
    // ── technology ──
    { term: "AI", full: "artificial intelligence" },
    { term: "API", full: "application programming interface" },
    { term: "RBAC", full: "role-based access control" },
    { term: "OCR", full: "optical character recognition" },
    { term: "AES-256-GCM", full: "Advanced Encryption Standard, 256-bit key, Galois/Counter Mode" },
    { term: "SHA-256", full: "Secure Hash Algorithm, 256-bit" },
    { term: "ASIC", full: "application-specific integrated circuit" },
    { term: "CSV", full: "comma-separated values", inline: false },
    { term: "PDF", full: "Portable Document Format", inline: false },
    { term: "XLSX", full: "Excel workbook", inline: false },
];
const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// Longest terms first, so "DoD SAFE" wins over "DoD" and "SAM.gov" over "SAM".
const INLINE = GLOSSARY.filter((g) => g.inline !== false).sort((a, b) => b.term.length - a.term.length);
// Spell out the first use of each acronym in a passage: "NAICS" becomes
// "North American Industry Classification System (NAICS)". Skips an acronym
// the passage already spells out, and never touches links or code-like words.
export function spellOut(text) {
    let out = text;
    const done = new Set();
    for (const g of INLINE) {
        if (done.has(g.full) || out.toLowerCase().includes(g.full.toLowerCase()))
            continue;
        const re = new RegExp(`(?<![\\w.@:-])${esc(g.term)}(s?)(?![\\w-]|\\.[a-z]|\\s*\\()`);
        const m = re.exec(out);
        if (!m)
            continue;
        const plural = m[1] === "s";
        const full = plural ? g.plural ?? `${g.full}s` : g.full;
        out = `${out.slice(0, m.index)}${full} (${g.term}${m[1]})${out.slice(m.index + m[0].length)}`;
        done.add(g.full);
    }
    return out;
}
